import {
  getAccountsURL,
  getCRMURL,
  getInsightsURL,
  getPerspectiveURL,
  getUnisonURL,
} from '@/api/getURL';

export const HEADER_HEIGHT = '4rem';

export const PLATFORMS = {
  CRM: `${getCRMURL()}/dashboard/overview/`,
  INSIGHTS: `${getInsightsURL()}/dashboard/overview/`,
  UNISON: `${getUnisonURL()}/dashboard/overview/`,
  PERSPECTIVE: getPerspectiveURL(),
  ACCOUNTS: getAccountsURL(),
};
